import { UserDto } from "../../models";
export const getUsernamebyId = (id: string, data: UserDto[]) => {
  return data.find((item) => item.userId === id)?.firstName;
};
